import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { language, t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4 inline-block bg-white rounded-lg p-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_4471c19e-bde9-4b97-9a10-805621e3566d/artifacts/hi6ooqhu_IMG_0005.jpeg"
                alt="Gravante Solar Logo"
                className="h-12 w-auto"
                style={{ 
                  display: 'block',
                  objectFit: 'contain'
                }}
              />
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              {language === 'en' 
                ? 'Your reliable partner for photovoltaics and heat pumps in Germany.'
                : 'Ihr zuverlässiger Partner für Photovoltaik und Wärmepumpen in Deutschland.'}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-sky-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-sky-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-sky-600 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('schnelllinks')}</h3>
            <ul className="space-y-2">
              <li>
                <a href="#produkte" className="text-gray-400 hover:text-sky-400 transition-colors">
                  {language === 'en' ? 'Products' : 'Produkte'}
                </a>
              </li>
              <li>
                <a href="#vorteile" className="text-gray-400 hover:text-sky-400 transition-colors">
                  {language === 'en' ? 'Benefits' : 'Vorteile'}
                </a>
              </li>
              <li>
                <a href="#prozess" className="text-gray-400 hover:text-sky-400 transition-colors">
                  {language === 'en' ? 'Process' : 'Prozess'}
                </a>
              </li>
              <li>
                <a href="#referenzen" className="text-gray-400 hover:text-sky-400 transition-colors">
                  {language === 'en' ? 'References' : 'Referenzen'}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-400 hover:text-sky-400 transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('leistungen')}</h3>
            <ul className="space-y-2 text-gray-400">
              <li>{language === 'en' ? 'Photovoltaic Systems' : 'Photovoltaikanlagen'}</li>
              <li>{language === 'en' ? 'Heat Pumps' : 'Wärmepumpen'}</li>
              <li>{language === 'en' ? 'Energy Storage' : 'Energiespeicher'}</li>
              <li>{language === 'en' ? 'Maintenance & Service' : 'Wartung & Service'}</li>
              <li>{language === 'en' ? 'Consulting & Planning' : 'Beratung & Planung'}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('kontakt')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400">
                <Phone className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-sky-400" />
                <span>+49 157 82283963</span>
              </li>
              <li className="flex items-start text-gray-400">
                <Mail className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-sky-400" />
                <span>Buchhaltung@gravante.de</span>
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-sky-400" />
                <span>Am Wammesknopf 6<br />70439 Stuttgart</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Gravante Solar. {t('alleRechteVorbehalten')}.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/impressum" className="text-gray-400 hover:text-sky-400 text-sm transition-colors">
                {t('impressum')}
              </Link>
              <Link to="/datenschutz" className="text-gray-400 hover:text-sky-400 text-sm transition-colors">
                {t('datenschutz')}
              </Link>
              <a href="#" className="text-gray-400 hover:text-sky-400 text-sm transition-colors">
                {t('agb')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
